import React, { ChangeEvent } from "react";
import styles from "./SearchInput.module.scss";
import CustomButton from "../ui/CustomButton/CustomButton";
import searchIconWhite from "../../assets/images/icons/search-icon-white.svg";
import plusIconWhite from "../../assets/images/icons/plus-white.svg";
import resetIcon from "../../assets/images/icons/close-grey.svg";
import { useTranslation } from "react-i18next";

interface SearchInputProps {
  addNewBtn: boolean;
  onClickAddNew?: () => void;
  onClickSearch: () => void;
  clickOnReset: () => void;
  inputValue: string;
  setInputValue: (value: string) => void;
  placeholder?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
  addNewBtn,
  onClickAddNew,
  inputValue,
  setInputValue,
  onClickSearch,
  placeholder,
  clickOnReset,
}) => {
  const { t } = useTranslation();

  const onChangeValue = (event: ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
  };

  const resetHandler = () => {
    setInputValue("");
    clickOnReset();
  };

  return (
    <div className={styles.container}>
      <div className={styles.right}>
        <div className={styles.inputWrapper}>
          <input
            className={styles.input}
            value={inputValue}
            onChange={onChangeValue}
            placeholder={placeholder || t("Search") + "..."}
          />
          <img onClick={resetHandler} className={styles.reset} src={resetIcon} alt={"reset"} />
        </div>

        <div className={styles.btnWrapper}>
          <CustomButton
            text={""}
            type={"button"}
            typeStyle={"fill"}
            icon={searchIconWhite}
            altIcon={"search"}
            functionOnClick={onClickSearch}
          />
        </div>
      </div>

      {addNewBtn && (
        <div className={styles.addNewBtnWrapper}>
          <CustomButton
            text={t("AddNew")}
            type={"button"}
            typeStyle={"fill"}
            icon={plusIconWhite}
            altIcon={"add"}
            functionOnClick={onClickAddNew}
          />
        </div>
      )}
    </div>
  );
};

export default SearchInput;
